import {
  Briefcase,
  Building,
  ClipboardList,
  FileCheck,
  FilePlus,
  Files,
  FileSearch,
  FileText,
  Folder,
  Handshake,
  Lock,
  Scale,
  Shield,
  Sparkles,
  UserCheck,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * Reusable icon picker options for admin Template forms (edit + create) and
 * for any UI that renders a template's icon by its persisted string value.
 *
 * Two exports:
 *   - `buildIconOptions(t)` — returns the labelled options for the picker.
 *   - `getIconComponent(value)` — resolves a Template.icon string back to its
 *     Lucide component, with FileText as the fallback.
 */

export interface IconOption {
  value: string;
  label: string;
  icon: LucideIcon;
}

export const TEMPLATE_ICON_COMPONENTS: Record<string, LucideIcon> = {
  FileText,
  Users,
  Lock,
  Shield,
  Sparkles,
  FileCheck,
  FilePlus,
  FileSearch,
  Files,
  Folder,
  Scale,
  Briefcase,
  Building,
  Handshake,
  UserCheck,
  ClipboardList,
};

export const buildIconOptions = (t: (key: string) => string): IconOption[] => [
  { value: 'FileText', label: t('ORGTEMPLATES_ICONS_FILETEXT'), icon: FileText },
  { value: 'Users', label: t('ORGTEMPLATES_ICONS_USERS'), icon: Users },
  { value: 'Lock', label: t('ORGTEMPLATES_ICONS_LOCK'), icon: Lock },
  { value: 'Shield', label: t('ORGTEMPLATES_ICONS_SHIELD'), icon: Shield },
  { value: 'Sparkles', label: t('ORGTEMPLATES_ICONS_SPARKLES'), icon: Sparkles },
  { value: 'FileCheck', label: t('ORGTEMPLATES_ICONS_FILECHECK'), icon: FileCheck },
  { value: 'FilePlus', label: t('ORGTEMPLATES_ICONS_FILEPLUS'), icon: FilePlus },
  { value: 'FileSearch', label: t('ORGTEMPLATES_ICONS_FILESEARCH'), icon: FileSearch },
  { value: 'Files', label: t('ORGTEMPLATES_ICONS_FILES'), icon: Files },
  { value: 'Folder', label: t('ORGTEMPLATES_ICONS_FOLDER'), icon: Folder },
  { value: 'Scale', label: t('ORGTEMPLATES_ICONS_SCALE'), icon: Scale },
  { value: 'Briefcase', label: t('ORGTEMPLATES_ICONS_BRIEFCASE'), icon: Briefcase },
  { value: 'Building', label: t('ORGTEMPLATES_ICONS_BUILDING'), icon: Building },
  { value: 'Handshake', label: t('ORGTEMPLATES_ICONS_HANDSHAKE'), icon: Handshake },
  { value: 'UserCheck', label: t('ORGTEMPLATES_ICONS_USERCHECK'), icon: UserCheck },
  { value: 'ClipboardList', label: t('ORGTEMPLATES_ICONS_CLIPBOARDLIST'), icon: ClipboardList },
];

export const getIconComponent = (value: string | undefined | null): LucideIcon =>
  TEMPLATE_ICON_COMPONENTS[value ?? 'FileText'] ?? FileText;
